/** @jsxImportSource @emotion/react */
import tw from 'twin.macro';

export const TableResponsive = tw.table`min-w-full bg-white flex flex-row flex-nowrap sm:table`;
export const TableHeadResponsive = tw.thead`bg-gray-800 text-white`;
export const TableHeadThResponsive = tw.th`text-left py-3 px-4 uppercase font-semibold text-sm`;
export const TableRowResponsive = tw.tr`flex flex-col flex-nowrap sm:table-row border-b border-gray-200 sm:border-none`;
export const TableRowTdResponsive = tw.td`text-left py-3 px-4`;
